// extracted by mini-css-extract-plugin
export var orderDetails = "_rl-2";
export var orderImage = "_rl-1";
export var orderMeta = "_rl-3";
export var orderSummary = "_rl-0";
export var rightArrow = "_rl-4";